// Copyright (c) StrangeBee 2023

import React, { ReactElement } from 'react';
import { ICONS } from '@Constants/iconsApp';

interface IsCheckedProps {
    checked: boolean;
    className?: string;
}

export const IsChecked = ({ checked, className }: IsCheckedProps): ReactElement => (
    <span className={className}>{checked ? <ICONS.CheckCircleTwoTone /> : <ICONS.CheckCircleOutlined />}</span>
);
